const viewStoreName = {
	sellerListViewStore: 'sellerListViewStore',
	channelListViewStore: 'channelListViewStore',
	channelEditViewStore: 'channelEditViewStore',
	orderListViewStore: 'orderListViewStore',
	marketplaceOrderListViewStore: 'marketplaceOrderListViewStore',
	scheduledJobLogListViewStore: 'alertsViewStore.scheduledJobLogListViewStore'
};

export { viewStoreName };
